<template>
  <div class="page-content">
    <div class="flex-view">
      <img src="@/assets/images/gov/img01.png" alt="" />
      <div class="view-info">
        <div class="page-title">Introductions</div>
        <div class="text">
          The World Congress is the supreme organ of the World Federation, which
          consists of the representatives of WFUCA’s Members. It meets every
          four years. <br />
          The World Congress determines the General Rules and the guidelines of
          work of the Organization. Its duty is to set the programmes and the
          budget of WFUCA. It also elects the Members of the Executive Board and
          the President.
          <br />
          The World Congress is the supreme organ of the World Federation, which
          consists of the representatives of WFUCA’s Members. It meets every
          four years.
          <br />
          The World Congress determines the General Rules and the guidelines of
          work of the Organization. Its duty is to set the programmes and the
          budget of WFUCA. It also elects the Members of the Executive Board and
          the President.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  width: 100%;
  > img {
    width: fw(400vw, pc);
    height: fw(400vw, pc);
    display: block;
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(42vh, pc);
    text-align: justify;
  }
  .text {
    margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
  }
  .flex-view {
    width: 100%;
    display: flex;
    align-items: flex-start;
    img {
      width: fw(360vw, pc);
      display: block;
      margin-right: fw(20vw, pc);
    }
    .view-info {
      flex: 1;
      .text {
        margin-top: fh(12vh, pc);
      }
    }
  }
}
</style>
